module.exports = ".comment .title {\n  padding: 5px; }\n  .comment .title .comment-actions {\n    float: right; }\n  .comment .title .comment-actions .btn i {\n      margin-right: 0; }\n  .panel-footer {\n  height: auto !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-comments/src/app/plugins/comment-relation/comment-relation.plugin.scss
// module id = ./libs/chassis-comments/src/app/plugins/comment-relation/comment-relation.plugin.scss
// module chunks = main